/* istanbul ignore file */

import React from 'react';
import {
  getNothsBlackLogoUrl,
  getNothsLogoUrl,
  getStaticFilesEnv,
} from '@noths/polaris-client-static-files';

import * as styles from './SiteLogo.styles';
import type { Environment } from 'client-site-chrome-ui/environment';

interface SiteLogoProps {
  env: Environment;
}

const isClockBetweenDates = (start: string, end: string) => {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * 60000;
  const currentTime = now.getTime() - timezoneOffset;
  const startTime = new Date(start).getTime();
  const endTime = new Date(end).getTime();

  return currentTime >= startTime && currentTime <= endTime;
};

export const SiteLogo = ({ env = 'production' }: SiteLogoProps) => {
  const staticFilesEnv = getStaticFilesEnv(env);

  const blackFridaySale = isClockBetweenDates(
    '2023-11-14T00:01:00.000Z',
    '2023-11-28T23:59:00.000Z',
  );

  const logoUrl = blackFridaySale
    ? getNothsBlackLogoUrl(staticFilesEnv, '3001')
    : getNothsLogoUrl(staticFilesEnv, '3001');

  return <img alt="" css={styles.image} src={logoUrl} />;
};
